@if (showForm) {
  <app-care-team-template-form
    #templateForm
    [templateId]="editingTemplateId"
    (closed)="onFormClosed()"
    (saved)="onFormSaved()"
  ></app-care-team-template-form>
}

@if (!showForm) {
  <div class="care-team-container">
    <div class="care-team-search">
      <div
        fxLayout="column"
        fxLayoutAlign=""
        fxFlex="20"
        class="care-team-search-input"
      >
        <input matInput [placeholder]="'Name' | translate" [(ngModel)]="name" />
      </div>
      <div
        fxLayout="column"
        fxLayoutAlign=""
        fxFlex="20"
        class="care-team-search-input"
      >
        <nz-select
          [(ngModel)]="selectedCategoryId"
          [nzPlaceHolder]="'Category' | translate"
          nzAllowClear
          style="width: 100%"
        >
          @for (category of categoryOptions; track category.id) {
            <nz-option
              [nzValue]="category.id"
              [nzLabel]="category.display"
            ></nz-option>
          }
        </nz-select>
      </div>
      <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="1em"
        fxFlex="60"
        class="care-team-search-buttons"
      >
        <button class="search-button w-100" (click)="searchTemplatesForm()">
          <mat-icon>search</mat-icon>
          <div class="btn-text">{{ "Search" | translate }}</div>
        </button>
        <button class="register-button" (click)="createTemplate()">
          <i nz-icon nzType="icons:userAdd"></i>
          <div class="btn-text" style="padding-left: 10px">
            {{ "New Care Team" | translate }}
          </div>
        </button>
      </div>
    </div>

    <div class="care-team-table">
      <mat-table [dataSource]="data" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Name" | translate }}
          </mat-header-cell>
          <mat-cell
            mat-cell
            *matCellDef="let element"
            class="truncate-cell"
            [title]="element.name"
          >
            {{ element.name || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="category">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Category" | translate }}
          </mat-header-cell>
          <mat-cell
            mat-cell
            *matCellDef="let element"
            class="truncate-cell"
            [title]="element.careTeamCategoryDisplay"
          >
            {{ element.careTeamCategoryDisplay || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="note">
          <mat-header-cell *matHeaderCellDef>
            {{ "Note" | translate }}
          </mat-header-cell>
          <mat-cell
            mat-cell
            *matCellDef="let element"
            class="truncate-cell"
            [title]="element.note"
          >
            {{ element.note || "-" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="members">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ "Members" | translate }}
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element" class="truncate-cell">
            {{ element.participantCount }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="cttactions">
          <mat-header-cell *matHeaderCellDef>
            {{ "Actions" | translate }}
          </mat-header-cell>
          <mat-cell
            mat-cell
            *matCellDef="let element"
            class="ctt-action-buttons-gap"
          >
            <button class="ctt-action-button view" (click)="onView(element)">
              {{ "View" | translate }}
            </button>
            <button class="ctt-action-button edit" (click)="onEdit(element)">
              {{ "Edit" | translate }}
            </button>
            <button
              class="ctt-action-button delete"
              (click)="deleteTemplate(element)"
            >
              {{ "Delete" | translate }}
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator
        #paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="pageChange()"
        [length]="totalRecords"
        showFirstLastButtons
        [ngClass]="
          data.data.length === 0 ? 'care-team-content-paginator-hide' : ''
        "
      />
    </div>

    <span>
      @if (data.data.length == 0 && !isLoading) {
        <div
          fxLayout="column"
          fxLayoutAlign="center center"
          fxFlex="100"
          class="no-care-team-templates"
        >
          {{ "No Care Team Templates available." | translate }}
        </div>
      }
    </span>

    @if (isLoading) {
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="careteam-spinner"
      >
        <nz-spin nzSimple></nz-spin>
      </div>
    }
  </div>
}

<nz-modal
  [(nzVisible)]="isViewModalVisible"
  [nzTitle]="viewingTemplate?.name || ('Care Team Members' | translate)"
  (nzOnCancel)="closeViewModal()"
  [nzFooter]="null"
  [nzWidth]="600"
>
  <ng-container *nzModalContent>
    @if (viewLoading) {
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        class="view-modal-spinner"
      >
        <nz-spin nzSimple></nz-spin>
      </div>
    } @else if (viewingTemplate) {
      <div class="view-modal-category">
        {{ viewingTemplate.careTeamCategoryDisplay }}
      </div>

      @if (viewingTemplate.participants.length === 0) {
        <div class="view-empty-state">
          {{ "No care team members added yet" | translate }}
        </div>
      }

      @for (participant of viewingTemplate.participants; track participant.id) {
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxLayoutGap="1em"
          class="view-member-card"
        >
          @let participantName =
            participant.userDisplayName ||
            participant.externalDoctorDisplayName ||
            "";
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1em">
            <div class="view-member-avatar">
              {{ getInitials(participantName) }}
            </div>
            <div fxLayout="column">
              <div class="view-member-name">
                {{ participantName }}
              </div>
              <div class="view-member-subtitle">
                {{ participant.careTeamRoleDisplay }}
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="0.75em">
            @if (participant.displayOrder === 1) {
              <div class="view-member-external-badge">
                {{ "Team Lead" | translate }}
              </div>
            }
            @if (
              participant.externalDoctorId || participant.externalDoctorCymaId
            ) {
              <div class="view-member-external-badge">
                {{
                  participant.externalDoctorCymaId
                    ? ("CyMA" | translate)
                    : ("External" | translate)
                }}
              </div>
            }
            @if (participant.displayOrder) {
              <div class="view-member-order-badge">
                #{{ participant.displayOrder }}
              </div>
            }
          </div>
        </div>
      }
    }
  </ng-container>
</nz-modal>
